

import React, { useState, useEffect } from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10">
        <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center">Política de Privacidad</h1>
        <div className="prose max-w-none text-gray-700 leading-relaxed">
          <p>En El Ancla CR respetamos y valoramos su privacidad. Esta política de privacidad describe cómo recopilamos y utilizamos la información personal que usted nos proporciona únicamente al realizar un pedido en nuestro sitio web.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">¿Qué información recopilamos?</h2>
          <p>Solo recopilamos la información esencial que usted proporciona al completar un pedido, incluyendo:</p>
          <ul>
            <li>Nombre y apellidos</li>
            <li>Dirección de envío</li>
            <li>Número de teléfono</li>
            <li>Método de pago seleccionado</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">¿Para qué usamos su información?</h2>
          <p>Utilizamos sus datos exclusivamente para:</p>
          <ul>
            <li>Gestionar y procesar su pedido</li>
            <li>Contactarlo en caso de ser necesario para completar la entrega</li>
            <li>Enviar confirmaciones o información sobre su pedido</li>
          </ul>
          <p>No utilizamos su información con fines publicitarios ni la compartimos con terceros.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">¿Cómo protegemos su información?</h2>
          <p>Los datos que usted proporciona se almacenan de forma segura en nuestra base de datos para fines exclusivamente operativos relacionados con su compra. No recopilamos información automatizada ni utilizamos cookies de rastreo.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Sus derechos</h2>
          <p>Usted tiene derecho a solicitar la corrección o eliminación de su información personal en cualquier momento. Para hacerlo, contáctenos usando los medios detallados abajo.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cambios en esta política</h2>
          <p>Nos reservamos el derecho de actualizar esta política en cualquier momento. Cualquier cambio se publicará en esta misma página.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contáctenos</h2>
          <p>Si tiene dudas o desea ejercer sus derechos de privacidad, puede escribirnos a: info@elancla.store</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;